<template>
  <el-container>
	<el-header>
		<div class="h-left">
			<el-form class="form" ref="form" :model="form" label-width="85px">
				<el-form-item label="响应策略：" class="form-item">
				<el-input type="text" v-model="form.msg"></el-input>
				</el-form-item>
				<el-form-item label="响应时间：" class="form-item">
				<el-date-picker v-model="form.date" type="date" placeholder="选择日期">
				</el-date-picker>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" size="mini" style="margin-right: 10px;"> 查询</el-button>
					<el-button type="primary" size="mini">导出</el-button>
				</el-form-item>
			</el-form>
			</div>
	</el-header>
	<el-main>
		<div class="data-title">
			<p style="text-align: center;line-height: 40px;">数据列表</p>
			<p style="position: absolute;top: 0%;right: 10%;z-index: 100;">
				<el-button type="primary" size="mini">新建方案</el-button>
			</p>
		</div>
		<div style="width: 100%;">
		<el-table :data="tableData" border height="720px">
			<el-table-column prop="UserName" label="方案名称"></el-table-column>
			<el-table-column prop="DeviceName" label="目标负荷"></el-table-column>
			<el-table-column prop="date" label="策略组成"></el-table-column>
			<el-table-column prop="code" label="目标负荷"></el-table-column>
			<el-table-column prop="address" label="日累计响应"></el-table-column>
			<el-table-column prop="fff" label="完成度"></el-table-column>
			<el-table-column prop="date" label="日期"></el-table-column>
			<el-table-column label="操作" width="150">
			<template slot-scope="scope">
				<el-button type="text" size="small">添加策略</el-button>
				<el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
				<el-button type="text" size="small">删除</el-button>
			</template>
			</el-table-column>
		</el-table>
		</div>
		</el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          date: '',
          msg: ""
        },
        tableData: [{
          date: '2016-05-02',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-04',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-01',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-03',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }]
      }
    },
    methods: {
      handleClick() {}
    },
    mounted() {}
  }

</script>